import { SettingsLayout } from "./layout"
import { Section } from "./index"
import { TeamInvitationsSettings } from "./team_invitations"
import { UserManagement } from "./user_management"
import { usePageTitle } from "@/utils"

export function SettingsUsers() {
  usePageTitle("Users")
  return (
    <SettingsLayout>
      <UserManagementSection />
      <TeamInvitationsSection />
    </SettingsLayout>
  )
}

function UserManagementSection() {
  return (
    <Section title="Team Members" class="bg-white rounded-lg shadow-sm p-6">
      <UserManagement />
    </Section>
  )
}

function TeamInvitationsSection() {
  return (
    <Section title="Invite New Members" class="bg-white rounded-lg shadow-sm p-6">
      <TeamInvitationsSettings />
    </Section>
  )
}
